<template>
  <behaviors-form
    :id="0"
    @submit="addBehavior"
    @close="onClose"
  />
</template>
<script>
import BehaviorsForm from './BehaviorsForm.vue'

export default {
  name: 'CreateBehavior',
  components: {
    BehaviorsForm,
  },
  methods: {
    addBehavior(behavior) {
      this.$store.dispatch('cdn/addBehavior', behavior).then(() => {
        this.successToast('Behavior was added')
        this.onClose(behavior.distributionId)
      }).catch(error => this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating behavior.'))
    },

    onClose(id) {
      this.$router.push({ name: 'distribution-behaviors', params: { id } })
    },
  },
}
</script>
